import { render } from "./ScratchCard.vue?vue&type=template&id=f6c6453c"
import script from "./ScratchCard.vue?vue&type=script&lang=js"
export * from "./ScratchCard.vue?vue&type=script&lang=js"
script.render = render

export default script